module.exports = __webpack_public_path__ + "static/media/star.39d26cf2.svg";